"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
/**
 * Retains the previous value of the given variable. Use this alongside functional components/hooks to reference a previous value (similar to comparing against previous props).
 *
 * Before using this, consider if you are manually updating state. In which case, you can probably avoid using this, and just do something like:
 *
 * const [myPrevState, setMyPrevState] = useState(null);
 * const [myCurrentState, setMyCurrentState] = useState(null);
 * ...
 * setMyPrevState(myCurrentState)
 * setMyCurrentState(newValue);
 */
var usePreviousValue = function usePreviousValue(value) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
};
var _default = exports["default"] = usePreviousValue;